module.exports = __webpack_public_path__ + "files/c768120a137282ff8459b0f4d30c25b7.png";